import { toast } from "react-toastify";
import { useOutletContext, Form, type ActionFunction } from "react-router";

import { Api, type Types } from "@/services";
import { checkToastThemeOption, httpSuccessToast } from "@/utils";
import { DashboardFormPageWrapper, FormRow, SubmitBtn } from "@/components";

export const profileAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const file = formData.get("avatar") as File | undefined;
  const sizeLimit = 0.5 * Math.pow(1024, 2);
  const option = checkToastThemeOption();

  if (file && file.size > sizeLimit) {
    toast.error("Image size too large", option);
    return null;
  }

  const resp = await Api.UpdateUser(formData as unknown as Types.Request.UpdateUser);
  httpSuccessToast(resp, "Profile updated successfully");
  return null;
};

const Profile = () => {
  const { user } = useOutletContext<Types.Response.CurrentUser>();
  const { name, email, location, lastName } = user;

  return (
    <DashboardFormPageWrapper>
      <Form className="form" method="POST" encType="multipart/form-data">
        <h4 className="form-title">profile</h4>
        <div className="form-center">
          <div className="form-row">
            <label htmlFor="image" className="form-label">
              Select an image file (max 0.5 MB):
            </label>
            <input type="file" id="avatar" name="avatar" className="form-input" accept="image/*" />
          </div>
          <FormRow name="name" defaultValue={name} />
          <FormRow labelText="last name" name="lastName" defaultValue={lastName} />
          <FormRow type="email" name="email" defaultValue={email} />
          <FormRow name="location" defaultValue={location} />
          <SubmitBtn formBtn />
        </div>
      </Form>
    </DashboardFormPageWrapper>
  );
};

export default Profile;
